import React from 'react'
import ShoppingCartsData from './components/ShoppingCartsData'
import DocCode from '../DocCode';

const ShoppingCarts = () => {

    // {/* x---------------------------------x Shopping Carts Code Section x---------------------------------x */}s
    const ShoppingCartsCode =
        `
        import { useState } from 'react';

        function ShoppingCartsData() {
            const [items, setItems] = useState([
                {
                    id: 1,
                    name: 'Artwork Tee',
                    image: "https://tailwindui.com/plus/img/ecommerce-images/checkout-page-03-product-04.jpg",
                    color: 'Mint',
                    size: 'Medium',
                    price: 32.00,
                    inStock: true,
                },
                {
                    id: 2,
                    name: 'Basic Tee',
                    image: "https://tailwindui.com/plus/img/ecommerce-images/shopping-cart-page-01-product-02.jpg",
                    color: 'Charcoal',
                    size: 'Large',
                    price: 32.00,
                    inStock: false,
                    shipTime: '7-8 years',
                },
                {
                    id: 3,
                    name: 'Basic Tee',
                    image: "https://tailwindui.com/plus/img/ecommerce-images/shopping-cart-page-01-product-01.jpg",
                    color: 'Sienna',
                    size: 'Large',
                    price: 32.00,
                    inStock: true,
                },
            ]);

            const removeFromCart = (id) => {
                setItems(items.filter((item) => item.id !== id));
            };

            const calculateSubtotal = () => {
                return items.reduce((total, item) => total + item.price, 0);
            };

            return (
                <div className="container mx-auto p-4 pt-6">
                    <h2 className="text-4xl text-center font-bold mb-4 border-b pb-8">Shopping Cart</h2>
                    <div className="grid grid-cols-1 gap-4 divide-y">
                        {items.map((item) => (
                            <div key={item.id} className=" rounded p-4">
                                <div className="flex items-center gap-4">
                                    <img
                                        src={item.image}
                                        alt={item.name}
                                        className="w-28 h-w-28 rounded"
                                    />
                                    <div>
                                        <h3 className="font-bold text-lg">{item.name}</h3>
                                        <p>
                                            {item.color} / {item.size}
                                        </p>
                                        {item.inStock ? (
                                            <span className="text-green-500">In stock</span>
                                        ) : (
                                            <span className="text-orange-50 ">
                                                Out of stock ({item.shipTime})
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="flex justify-between mt-4">
                                    <p className="text-lg">{item.price}</p>
                                    <button
                                        onClick={() => removeFromCart(item.id)}
                                        className="text-blue-500 hover:text-blue-700 font-bold"
                                    >
                                        Remove
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="flex justify-between mt-4">
                        <p className="text-lg">Subtotal:</p>
                        <p className="text-lg">{calculateSubtotal().toFixed(2)}</p>
                    </div>
                </div>
            );
        }

        export default ShoppingCartsData;
        `

    return (
        // {/* x---------------------------------x DocCode Component Section x---------------------------------x */}
        <DocCode
            heading={"Shopping Carts"}
            headingText={"Use these Tailwind CSS shopping cart components to provide customers with an overview of their selected items, including quantities, pricing, and the ability to update or remove products before checkout. These shopping cart components are designed and built by the Tailwind CSS team, and include a variety of different styles and layouts."}
            code={ShoppingCartsCode}
            // {/* x---------------------------------x Shopping Carts Preview Section x---------------------------------x */}
            Preview={<ShoppingCartsData />}
        />
    )
}

export default ShoppingCarts;